import { createApiClient } from "../../shared/api/rpc-client";
import { getCurrentIdToken, signInWithGoogle, signOutCurrentUser } from "../../shared/firebase/firebase-auth";

async function requireIdToken(): Promise<string | null> {
  return getCurrentIdToken();
}

async function readApiResponse(response: Response): Promise<unknown> {
  const body = await response.json();
  if (!response.ok) {
    const message = body && typeof body === "object" && "error" in body
      ? JSON.stringify(body.error)
      : "Request failed";
    throw new Error(message);
  }
  return body;
}

export async function loginWithGoogleAndLoadMember(): Promise<unknown> {
  await signInWithGoogle();
  return loadCurrentMember();
}

export async function loadCurrentMember(): Promise<unknown> {
  const token = await requireIdToken();
  if (!token) {
    return null;
  }

  const response = await createApiClient().api.v1.me.$get(
    {},
    { headers: { Authorization: `Bearer ${token}` } },
  );

  return readApiResponse(response);
}

export async function updateNickname(nickname: string): Promise<unknown> {
  const token = await requireIdToken();
  if (!token) {
    return null;
  }

  const response = await createApiClient().api.v1.me.$patch(
    { json: { nickname } },
    { headers: { Authorization: `Bearer ${token}` } },
  );

  return readApiResponse(response);
}

export async function logout(): Promise<void> {
  await signOutCurrentUser();
}
